<template>
  <div>
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box box-primary">
          <form @submit.prevent>
            <div class="box-body">
              <div class="form-group col-md-10">
                <label for="inputName">ID</label>
                <h1 style="margin-top:0px;">
                  <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName" placeholder="Payment ID" v-model="formData.id">
                </h1>                        
              </div>
              <div class="form-group col-md-2">
                <!-- <h3 style="margin-top:0px;">
                  <span class="label label-success pull-right">{{ formData.status}}</span>
                </h3>                      -->
              </div>                                 
              <div class="row">
                <div class="col-md-12">
                  <div class="nav-tabs-custom">
                    <ul class="nav nav-tabs">
                      <li v-bind:class="{ active: tabActive == TAB_OVERVIEW }"><a href="#tab_1" data-toggle="tab" aria-expanded="true">Overview</a></li>
                      <li v-bind:class="{ active: tabActive == TAB_LOG }"><a @click="onClickTabLog()" href="#tab_2" data-toggle="tab" aria-expanded="true">Log</a></li>
                    </ul>
                  </div>
                  <div class="tab-content">
                    <div v-bind:class="{ active: tabActive == TAB_OVERVIEW }" class="tab-pane" id="tab_1">
                      <div class="box no-border form-horizontal">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputOrderID" class="col-sm-4 control-label">Order ID</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputOrderID" placeholder="" v-model="formData.order_id">
                              </div>                     
                            </div>                                         
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputPaymentID" class="col-sm-4 control-label">Payment ID</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputPaymentID" placeholder="" v-model="formData.payment_id">
                              </div>                     
                            </div>                      
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputTransactionID" class="col-sm-4 control-label">Payment Item ID</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputTransactionID" placeholder="" v-model="formData.payment_item_id">
                              </div>
                            </div>                                         
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputPaymentMethod" class="col-sm-4 control-label">Payment Method</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputPaymentMethod" placeholder="" v-model="formData.payment_method_name">
                              </div>                     
                            </div>                      
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputBookingDate" class="col-sm-4 control-label">Booking Date</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputBookingDate" placeholder="" v-model="formData.booking_date">
                              </div>                     
                            </div>                                         
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputIsUsed" class="col-sm-4 control-label">Is Used</label>
                              <div class="col-md-8">
                                <input :disabled="viewMode == MODE_VIEW" type="checkbox" id="inputIsUsed" v-model="formData.is_used">
                              </div>                     
                            </div>                      
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputUsingDate" class="col-sm-4 control-label">Using Date</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputUsingDate" placeholder="" v-model="formData.using_date">
                              </div>                     
                            </div>                                          
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputItemID" class="col-sm-4 control-label">Item ID</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputItemID" placeholder="" v-model="formData.item_id">
                              </div>                     
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputItemName" class="col-sm-4 control-label">Item Name</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputItemName" placeholder="" v-model="formData.item_name">
                              </div>                     
                            </div>                                         
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputProject" class="col-sm-4 control-label">Project</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputProject" placeholder="" v-model="formData.project_name">
                              </div>                     
                            </div>
                          </div>
                        </div>                        
                      </div>
                    </div>                   
                    <div v-bind:class="{ active: tabActive == TAB_LOG }" class="tab-pane" id="tab_2">
                      <div class="box no-border">
                        <div class="box-header">
                        </div>                                                     
                        <div class="box-body no-padding table-responsive">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th style="width:30px;text-align:right">#</th>
                                <th style="text-align:center;">Gate ID</th>
                                <th style="text-align:center;">Process Date</th>
                                <th style="text-align:center;">Status</th>
                                <th style="text-align:left;">Message</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(row, i) in listLog" v-bind:key="i">
                                <td style="width:30px;text-align:right;">{{ startSequenceLog + i + 1}}</td>
                                <td style="text-align:center;" nowrap>{{ row.gate_id }}</td>
                                <td style="text-align:center;">{{ row.process_date }}</td>
                                <td style="text-align:center;">{{ row.status }}</td>
                                <td style="text-align:left;">{{ row.message }}</td>
                                <td hidden>{{ row.id }}</td>
                                <td hidden>{{ row.pass_code_id }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="box-footer">
                        </div>                        
                      </div>
                    </div> 
                  </div>
                </div>
              </div>                                                                     
            </div>

            <div class="box-footer">
              <div class="box-tools">
                <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>
              </div>
            </div>

          </form>
        </div>          
      </div>
    </div>
  </div>  
</template>

<script>
// import $ from 'jquery'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'

const MODE_NONE = 'none'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'
const TAB_OVERVIEW = 'tabOverview'
const TAB_LOG = 'tabLog'

export default {
  name: 'PassCodeForm',
  components: {
    datepicker
  },
  data() {
    return {
      callback: '',
      DATE_FORMAT: config.dateFormat,
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      TAB_OVERVIEW: TAB_OVERVIEW,
      TAB_LOG: TAB_LOG,
      viewMode: MODE_NONE,
      formData: {
        id: 0,
        name: '',
        project_id: 0,
        order_id: '',
        payment_id: '',
        payment_item_id: '',
        transaction_id: '',
        payment_method_id: '',
        payment_method_name: '',
        booking_date: '',
        is_used: false,
        using_date: '',
        item_id: '',
        item_name: ''
      },
      listLog: null,
      startSequenceLog: 0,
      tabActive: '',
      originalcallback: '',
      prevRoute: null
    }
  },
  computed: {
  },
  created() {
    this.formData.id = this.$route.params.id
    this.viewMode = this.$route.params.mode
    this.callback = this.$route.params.callback
    this.callbackId = this.$route.params.callbackId
    this.originalcallback = this.$route.params.originalcallback
    this.tabActive = TAB_OVERVIEW
    this.clearing = this.$route.params.clearingStatus
    this.getDetail(this.clearing)
  },
  mounted() {
  },
  methods: {
    getDetail(clearingStatus) {
      let baseUrl = config.environment === 'Local' ? '/api/Gate' : '/api/Gate/' + this.$store.state.userInfo.projects[0]
      api
        .request('Gate', 'get', baseUrl + '/PassCode/' + this.formData.id, null)
        .then(response => {
          var data = response.data
          this.formData = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onClickTabLog() {
      this.inquiryLog()
    },
    inquiryLog() {
      let baseUrl = config.environment === 'Local' ? '/api/Gate' : '/api/Gate/' + this.$store.state.userInfo.projects[0]
      api
        .request('Gate', 'get', baseUrl + '/PassCode/' + this.formData.id + '/Log', null)
        .then(response => {
          var data = response.data
          this.listLog = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onBack() {
      let params = {
        mode: MODE_VIEW,
        callbackId: this.callbackId,
        callback: this.callback
      }
      this.$router.push({ name: this.callback, params: params })
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}

.q_avatar {
  float: left;
  box-sizing: border-box;
  position: relative;
  text-align: inherit;
}
.q_avatar > img {
  max-height: 90px;
  max-width: 90px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  border: none;
}
.q_form_image_controls {
  position: absolute;
  top: 0;
  left: auto;
  bottom: auto;
  right: 0;
  width: 100%;
  color: white;
  background-color: #337AB7;
  opacity: 0;
  transition: opacity ease 400ms;
}
.q_hidden_input_file {
  position: absolute;
  top: 1px;
  opacity: 0;
  width: 100%;
  height: 26px;  
  display: none;
}
.q_form_image_controls > .ion {
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// PassCodeForm.vue?ce57affa